var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid } from "@mui/material";
import { CustomRadioGroup } from "../../../../components/Forms/CustomRadioGroup";
import { ShowContent } from "../../../../components/ShowContent";
import { CustomInputForm } from "../../../../components/Forms/CustomInputForm";
export var DadosSipra = function (_a) {
    var _b;
    var possuiCadSipra = _a.possuiCadSipra, onChange = _a.onChange, fieldError = _a.fieldError, dadosImovel = _a.dadosImovel, onPossuiCadSipraChange = _a.onPossuiCadSipraChange;
    var handleChangeSIPRA = function (event) {
        var newValue = event.target.value === "true";
        onPossuiCadSipraChange === null || onPossuiCadSipraChange === void 0 ? void 0 : onPossuiCadSipraChange(newValue);
        if (!newValue) {
            onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, dadosImovel), { codigoSipra: "" }));
        }
    };
    // handleChange removido pois não é mais necessário
    return (_jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, display: "flex" }, { children: _jsx(CustomRadioGroup, { value: possuiCadSipra ? "true" : "false", onChange: handleChangeSIPRA, 
                    // helperText={fieldsErrors?.nameError}
                    // error={!!fieldsErrors?.nameError}
                    label: "Possui cadastro do SIPRA?", name: "possuiSipra", required: true, collumn: true, options: [
                        { label: "Sim", value: "true" },
                        { label: "Não", value: "false" },
                    ] }, "tipo-sipra-opts") })), _jsx(ShowContent, __assign({ show: possuiCadSipra }, { children: _jsx(Grid, __assign({ item: true, xs: 6 }, { children: _jsx(CustomInputForm, { onChange: function (event) {
                            onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, dadosImovel), { codigoSipra: event.target.value }));
                        }, helperText: (fieldError === null || fieldError === void 0 ? void 0 : fieldError.codigoSipraError) || "", error: !!(fieldError === null || fieldError === void 0 ? void 0 : fieldError.codigoSipraError), value: (_b = dadosImovel === null || dadosImovel === void 0 ? void 0 : dadosImovel.codigoSipra) !== null && _b !== void 0 ? _b : "", label: "C\u00F3digo SIPRA do Assentado", name: "codigoSipra", id: "codigoSipra", required: true }) })) }))] })));
};
